'use client';

import React, { type ComponentProps } from 'react';
import { type CartItemV2, Fragment } from '@kidslabs/mario-nextjs-react-ui-core';
import { CartItemStockAvailability } from '@kidslabs/module-quote';
import { FlashSaleStatus } from '@kidslabs/module-flash-sale';

/**
 * CartItemAdditionalInformation - Additional info rendered below cart item
 *
 * Matches mobile module-theme-hermes implementation:
 * - CartItemStockAvailability: Shows stock status (out of stock, low stock, etc.)
 * - FlashSaleStatus: Shows flash sale countdown/status if applicable
 *
 * Note: Props come from CartItemV2 BaseCartItemV2Props.
 * Both child components accept item with CartItem type from module-quote.
 * We cast the item since BaseCartItemInterface is structurally compatible.
 *
 * @see mobile-ecommerce/applications/module-theme-hermes/src/modules/quote/components/cart-item-additional-information/cart-item-additional-information.tsx
 */
export const CartItemAdditionalInformation: ComponentProps<typeof CartItemV2>['CartItemAdditionalInfoComponent'] = ({
    item,
}) => {
    // Cast item to match child component expected types
    // BaseCartItemInterface is structurally compatible with CartItem
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cartItem = item as any;

    return (
        <Fragment>
            <CartItemStockAvailability item={cartItem} />
            {FlashSaleStatus && <FlashSaleStatus item={cartItem} />}
        </Fragment>
    );
};

export default CartItemAdditionalInformation;
